import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SortType} from "../../../commons/types/sort.type";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {BillingAccountDateType} from "../../types/billing-account-date.type";

export class ConsolidatedBillingOrdersTableCtrl implements IController {
  excludeMode: any;
  selectedIds: any;
  from: number;
  to: number;
  filterDateType?: BillingAccountDateType;
  query: string;
  billingAccountIds: string[];
  status: string;
  hasPrice: boolean;
  hasInvoiceError: boolean;

  sortType: {
    name: string,
    type: SortType
  };
  onSortTypeChange: Function;
  onSelect: Function;
  onEdit: Function;
  onExportPdf: Function;
  onExportCsv: Function;
  payManually: Function;
  onAddBillingOrders: Function;
  onCreateRefund: Function;
  resetPayManually: Function;
  onPrint: Function;
  onDelete: Function;
  onSelectChange: Function;

  public selectedKeys: any;
  public billingOrdersRef: any;
  public loadLimit = 20;
  public infiniteScroll: any;
  public isScrollable: any;
  public asceDescIconsMap: any;


  constructor(private $infiniteScroll, private $consolidatedBillingOrders, private moment,
              private $log, private commonsAlertsService: CommonsAlertsService, private $mdMedia, private commonsConstants) {
    this.asceDescIconsMap = this.commonsConstants.sortIconsMap;
  }

  $onInit() {
    this.billingOrdersRef = this.$consolidatedBillingOrders();
    this.billingOrdersRef.$query(this._getBillingOrdersQuery());
    this.infiniteScroll = this.$infiniteScroll(this.billingOrdersRef, this.loadLimit, {getFullData: true});
  };

  $onChanges(changes) {
    if (changes.selectedIds) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      });
    }

    if (
      (changes.from && !changes.from.isFirstChange()) ||
      (changes.to && !changes.to.isFirstChange()) ||
      (changes.filterDateType && !changes.filterDateType.isFirstChange()) ||
      (changes.query && !changes.query.isFirstChange()) ||
      (changes.accountId && !changes.accountId.isFirstChange()) ||
      (changes.billingAccountIds && !changes.billingAccountIds.isFirstChange()) ||
      (changes.status && !changes.status.isFirstChange()) ||
      (changes.hasPrice && !changes.hasPrice.isFirstChange()) ||
      (changes.sortType && !changes.sortType.isFirstChange() ||
        (changes.hasInvoiceError && !changes.hasInvoiceError.isFirstChange()))
    ) {
      this._loadBillingOrders();
    }
  };

  $doCheck() {
    this.isScrollable = !this.$mdMedia('gt-md');
  };


  onToggleSelectAll() {
    this.onSelectChange({selectedIds: [], excludeMode: !this.excludeMode})
  }

  onToggle(billingOrder) {
    this.selectedKeys[billingOrder.id] = !this.selectedKeys[billingOrder.id];
    this.onSelectChange({
        selectedIds: _.keys(_.pickBy(this.selectedKeys, _.identity)),
        excludeMode: this.excludeMode
      }
    );
  }

  private _loadBillingOrders() {
    this.billingOrdersRef.$query(this._getBillingOrdersQuery())
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.commonsAlertsService.somethingWentWrongError();
        this.$log.error('Failed to load billing accounts ', error);
      })
  }

  private _getBillingOrdersQuery() {
    return {
      limit: this.loadLimit,
      query: this.query,
      filterDateType: this.filterDateType,
      billingAccountIds: this.billingAccountIds,
      statuses: this.status ? [this.status] : undefined,
      from: this.from,
      to: this.to,
      hasPrice: this.hasPrice,
      isLastInvoicingFailed : this.hasInvoiceError ? true : undefined,
      sort: this.sortType ? `${this.sortType.name},${this.sortType.type}` : undefined
    }
  }
}

angular
  .module('bringoz.admin.billing-accounts')
  .component('consolidatedBillingOrdersTable', {
    bindings: {
      excludeMode: '<',
      selectedIds: '<?',
      from: '<?',
      to: '<?',
      filterDateType: '<?',
      query: '<?',
      billingAccountIds: '<?',
      status: '<?',
      hasPrice: '<',
      hasInvoiceError: '<?',
      sortType: '<?',
      onSortTypeChange: '&',
      onSelect: '&',
      onEdit: '&',
      onExportPdf: '&',
      onExportCsv: '&',
      payManually: '&',
      onAddBillingOrders: '&',
      onCreateRefund: '&',
      resetPayManually: '&',
      onPrint: '&',
      onDelete: '&',
      onSelectChange: '&'
    },
    template: require('./consolidated-billing-orders-table.html').default,
    controller: ConsolidatedBillingOrdersTableCtrl
  });
